import {useMemo} from "react";
import {Checkbox, ListItemText, MenuItem, TextField} from "@mui/material";
import {phaseOptions} from "../../../../misc/Phase";

export function PhaseFilterSelect(props: {
    phases: (string | null | undefined)[];
    value: string[];
    onChange(value: string[]): void;
}) {
    const options = useMemo(() => phaseOptions(props.phases), [props.phases]);

    return (
        <TextField
            select
            size="small"
            fullWidth
            label="Phases"
            value={props.value}
            InputLabelProps={{shrink: true}}
            SelectProps={{
                multiple: true,
                displayEmpty: true,
                renderValue: value => {
                    const list = value as string[];
                    if(list.length === 0) return "All phases";
                    return list.map(id => options.find(o => o.id === id)?.label || id).join(", ");
                },
            }}
            onChange={e => {
                const value = e.target.value as string | string[];
                props.onChange(typeof value === "string" ? value.split(",") : value);
            }}
        >
            {options.map(o => (
                <MenuItem key={o.id} value={o.id} dense>
                    <Checkbox size="small" checked={props.value.includes(o.id)} />
                    <ListItemText primary={o.label} />
                </MenuItem>
            ))}
        </TextField>
    )
}
